module.exports = __webpack_public_path__ + "img/entretenimiento_img.156d753c.png";